<template>
  <div style="margin-left:10%;">
    <!-- <div class="banner page-head flex-box">
      <div class="w-100">
        <div class="container">
          <div class="banner-caption">
            <h3>Android SDK Integration</h3>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row align-items-center justify-content-between">
      <!-- <div class="col-md-3" style="margin-top: 2%; margin-bottom: auto">
        <a class="list-group-item list-group-item-action" href="#Intro"
          >Introduction</a
        >
        <a class="list-group-item list-group-item-action" href="#step1"
          >Add Dependency to your build.gradle file</a
        >
        <a class="list-group-item list-group-item-action" href="#step2"
          >Add Dependency to your app module</a
        >
        <a class="list-group-item list-group-item-action" href="#step3"
          >Add library in your manifest file</a
        >
        <a class="list-group-item list-group-item-action" href="#step4"
          >Add the following code in your project where you want to call the
          sdk</a
        >
        <a class="list-group-item list-group-item-action" href="#step5"
          >Add the following code in your project where you want to call the
          sdk</a
        >
      </div> -->
      <div class="col-md-9" style="margin-top: 2%">
        <div id="Intro" style="margin-top: 0.5%">
          <h2 class="documentation-header">Introduction</h2>
          <p style="margin-top: 30px">
            Welcome to Android Chatbot SDK
            <br />
            <br />
            The SDK provides a flexible set of methods that can be used in
            your Android projects.
          </p>
        </div>
        <div class="row" style="margin-top: 10px" id="step1">
          <div class="col-md-12">
            <h3 class="documentation-header">Add dependencies to your build.gradle file</h3>
            <p>
              Make sure that your minSdkVersion is equal or higher than 21. Add
              the following line in your build.gradle file
            </p>
            <pre>
        dependencies {
        ...
        implementation 'com.android.support:support-v4:28.0.0'
        implementation 'com.android.support:recyclerview-v7:28.0.0'
        implementation 'com.squareup.picasso:picasso:2.5.2'
        implementation project(':chatbotapp')
        }                    
          </pre
            >
          </div>
        </div>
        <div class="row" style="margin-top: 10px" id="step2">
          <div class="col-md-10">
            <h3 class="documentation-header">Add dependency to your app module</h3>
            <p>
              Click on File > Project Structure and select your app module Add
              Module Dependency to your app module
            </p>
          </div>
        </div>
        <div class="row" style="margin-top: 10px" id="step3">
          <div class="col-md-10">
            <h3 class="documentation-header">Add library in your manifest file</h3>
            <p>Add the following line in your Manifest file</p>
            <pre>
        &lt;xmp&gt;
        &lt;uses-library android:name="com.cense.prod.chatbot" android:required="false"/&gt;
        &lt;/xmp&gt;
          </pre
            >
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-10" id="step4">
            <h3 class="documentation-header">
              Define the following variable in your project in order to call the
              sdk
            </h3>
            <pre style="margin-left: auto">
        String license_key = YOUR_VALID_LICENSE_KEY;
          </pre
            >
            <p style="margin-top: -2%">
              <strong
                >Please ensure that the license key is a valid one. The working
                of chatbot depends on a valid license key</strong
              >
            </p>
          </div>
          <div class="col-md-10"></div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-10" id="step5">
            <h3 class="documentation-header">
              Add the following code in your project where you want to call the
              sdk
            </h3>
            <p>
              Use the following Intent function to call the SDK library in your
              Activity.
              <br />
              <strong>Make sure</strong> that you don't change the key name in
              the following code.
            </p>
            <pre style="margin-left: auto">
        Intent in = new Intent(*YourActivity.this, ChatbotActivity.class); // * include your own activity.
        in.putExtra("license_key", license_key);
        startActivity(in);
            </pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "android",
  mounted() {
    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
      }
    }
    window.addEventListener("hashchange", offsetAnchor);
    window.setTimeout(offsetAnchor, 1);
  },
};
</script>


<style scoped>
/* p{
    font: normal normal normal 1rem/1.45px Poppins;
} */
p {
  font: normal normal normal 1rem/1.45rem Poppins;
}
.list-group-item {
  background-color: unset;
  border-width: 0px 0px 1px 0px;
}
pre {
  color: #ff1493;
  background: #f9fcff 0% 0% no-repeat padding-box;
}
@media (max-width: 768px) {
  .col-md-3,
  .col-md-9 {
    padding-left: 4%;
    padding-right: 4%;
  }
}
@media (min-width: 768px) {
  .col-md-3 {
    padding-left: 2%;
  }
}
</style>